<template>
  <b-modal id="modal-standard" title="Gestion de la transition" title-class="font-18" centered scrollable hide-footer
    v-model="isVisible" @hidden="closeConnectionDialog()">
    <div class="body">
      <label for="name">Action</label>
      <select id="type" class="form-control" v-model="connectionForm.action"
        @change="handleActionChange(connectionForm.action)">
        <option :key="action.id" v-for="action in actions" :value="action.id">
          {{ action.name }}
        </option>
      </select><br>
      <!-- <label>Déplacement automatique</label><br>
      <p v-if="connectionForm.movingPath" class="alert alert-success">
        <b>Destination</b>: {{ connectionForm.movingPath }}
      </p>
      <p v-else class="alert alert-warning">Aucune destination selectionnée</p>
      <input type="checkbox" v-model="canMoveDocument">
      <span class="ml-2" v-if="!connectionForm.movingPath"> Selectionner une destination</span>
      <span class="ml-2" v-else> Modifier la destination</span> -->
    </div>
    <div class="row">
      <div class="col-md-12">
        <folder-tree-select @selected="onPathSelected" v-if="canMoveDocument" />
        <br>
        <button class="btn btn-primary ml-2 mr-2" @click="handleClickSaveConnection">Enregistrer</button>
        <button class="btn btn-light" @click="handleClickCancelSaveConnection">Fermer</button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import actionsApi from "../../../api/actionsApi";
import FolderTreeSelect from '../../tree/FolderTreeSelect.vue';

export default {
  name: 'ConnectionDialog',
  components: {
    FolderTreeSelect,
      },
      props: {
    visible: {
      type: Boolean,
      default: false,
    },
    connection: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      connectionForm: {
        type: null,
        sourceId: null,
        sourcePosition: null,
        destinationId: null,
        destinationPosition: null,
        action: null,
        expression: null,
        movingPath: null,
      },
      canMoveDocument: false,
      actions: [],
      connectionDialogStyle: {
        top: 0,
        left: 0,
        width: '320px',
      },
    };
  },
  computed: {
    isVisible: {
      get: function () {
        return this.visible;
      },
      set: function (newValue) {
        return newValue;
      }
    },
  },
  methods: {
    closeConnectionDialog() {
      this.$emit('closed');
    },
    async handleClickSaveConnection() {
      this.$emit('closed');
      this.$emit('update:connection', Object.assign(this.connection, {
        action: this.connectionForm.action,
        type: this.connectionForm.type,
        movingPath: this.connectionForm.movingPath,
        expression: this.connectionForm.expression,
      }));
    },
    async handleClickCancelSaveConnection() {
      this.$emit('closed');
    },
    onPathSelected(event) {
      this.connectionForm.movingPath = event;
      this.canMoveDocument = false;
    },
    handleActionChange(actionId) {
      const actionType = this.actions.filter(e => e.id == actionId)[0].action_name;
      if (actionType === 'approve') {
        this.connectionForm.type = 'pass';
      } else {
        this.connectionForm.type = 'reject';
      }
    },
  },
  watch: {
    connection: {
      immediate: true,
      handler(val) {
        if (!val) { return; }
        this.connectionDialogStyle.top = `${ val.y } px`;
        this.connectionDialogStyle.left = `${ val.x } px`;
        this.connectionForm.id = val.id;
        this.connectionForm.type = val.type;
        this.connectionForm.action = val.action;
        this.connectionForm.movingPath = val.movingPath;
        this.connectionForm.expression = val.expression;
      },
    },
  },
  mounted() {
// TODO: fetch actions from backend
    actionsApi.get().then((response) => {
      this.actions = response.data.actions;
    });
    this.$store.dispatch('initializeApp');
  }
};
</script>

<style lang="scss" scoped>
  .modal {
    box-shadow: 2px 2px 1px #d3d3d3;
    background-color: white;
    position: absolute; 
    display: inline;
    // top: 60px;
    // left: 0;
    height: 500px;
    width: 400px !important;
    padding-bottom: 10px;
    box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
    border-radius: 6px;
    margin-left: auto;
    margin-right: auto;
    z-index: 10;
    overflow-y: scroll;
  }

  .body {
      padding: 10px;
  }

  .header {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
  }
</style>